module.exports = __webpack_public_path__ + "static/media/Aretha-front.0402f970.jpeg";